<router-outlet />
<ngx-sonner-toaster />

@if (_loaderService.getLoading()()) {
    <app-loader></app-loader>
}

@if (!isMobile()) {
    <app-desktop-message></app-desktop-message>
}

@if (_helpService.getStateButtonHelp()()) {
    <app-button-help></app-button-help>
}